// extracted by mini-css-extract-plugin
export default {"ButtonCancel":"ButtonCancel_ButtonCancel__HgBf5"};